export default "__VITE_ASSET__B$ypAH7w__"